import React from 'react';
import languageSDK from "../languages";
import StoreManager from "../appdata";
import { callAPIOcr } from "../api";
import StepBar from '../components/StepBar';

class EditOCRScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullName: '',
      dateOfBirth: '',
      gender: '',
      idNumber: '',
      givenDate: '',
      dueDate: '',
      placeOfIssue: '',
      permanentAddress: '',
      isCallingApi: false
    };
  }

  componentDidMount() {
    StoreManager.appdata.thisOcr = this;
    const { isCallingApi } = this.state;
    if (!isCallingApi) {
      this.setState({ isCallingApi: true });
      callAPIOcr();
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let tmp = Object.assign({}, this.state);
    let { isCallingApi, ...obj } = tmp;
    StoreManager.appdata.editOCR = obj;
    StoreManager.appdata.thisApp.nextStep();
  };

  render() {
    const {
      fullName,
      dateOfBirth,
      gender,
      dueDate,
      idNumber,
      givenDate,
      placeOfIssue,
      permanentAddress
    } = this.state;

    const configEkyc = StoreManager.appdata.configEkyc;
    const { ocrFieldsConfig = {} } = configEkyc;
    console.log("ocrFieldsConfig", ocrFieldsConfig)
    const baseField = {
      padding: '8px',
      width: '100%',
      boxSizing: 'border-box',
      border: '1px solid #DFE1E6',
      borderRadius: '6px',
      backgroundColor: '#fff',
      color: '#000',
      outline: 'none',
    };

    const selectField = {
      ...baseField,
      appearance: 'none',
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      backgroundImage:
        "url(data:image/svg+xml;charset=UTF-8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>)",
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 10px center',
      backgroundSize: '16px 16px',
    };

    // 🔧 Helper render field
    const renderField = (label, name, type = "text") => {
      const cfg = ocrFieldsConfig?.[name] || { visible: true, editable: true };
      if (!cfg.visible) return null; // ẩn field

      if (name === "gender") {
        return (
          <React.Fragment key={name}>
            <label>{label}</label>
            <select
              name="gender"
              value={gender}
              onChange={this.handleChange}
              style={{
                ...selectField,
                backgroundColor: cfg.editable ? "#fff" : "#f6f6f6",
              }}
              disabled={!cfg.editable}
            >
              <option value="MALE">{languageSDK.language.trueID_male}</option>
              <option value="FEMALE">{languageSDK.language.trueID_female}</option>
            </select>
          </React.Fragment>
        );
      }

      return (
        <React.Fragment key={name}>
          <label>{label}</label>
          <input
            type={type}
            name={name}
            value={this.state[name]}
            onChange={this.handleChange}
            style={{
              ...baseField,
              backgroundColor: cfg.editable ? "#fff" : "#f6f6f6",
            }}
            readOnly={!cfg.editable}
          />
        </React.Fragment>
      );
    };

    return (
      <div
        style={{
          margin: 'auto',
          fontFamily: 'Arial, sans-serif',
          maxWidth: 400,
          maxHeight: '80vh',
          overflowY: 'auto',
          paddingRight: 10,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <p
          style={{
            color: configEkyc.titleColor,
            fontSize: 20,
            fontWeight: 600,
            textAlign: 'center'
          }}
        >
          {languageSDK.language.trueID_ocr_title}
        </p>

        <StepBar />

        <form
          onSubmit={this.handleSubmit}
          style={{ display: 'flex', flexDirection: 'column', flex: 1 }}
        >
          <div style={{ display: 'grid', gridGap: 10, padding: 20, flex: 1 }}>
            {renderField(languageSDK.language.trueID_full_name, "fullName")}
            {renderField(languageSDK.language.trueID_dob, "dateOfBirth")}
            {renderField(languageSDK.language.trueID_gender, "gender")}
            {renderField(languageSDK.language.trueID_id_number, "idNumber")}
            {renderField(languageSDK.language.trueID_given_date, "givenDate")}
            {renderField(languageSDK.language.trueID_due_date, "dueDate")}
            {renderField(languageSDK.language.trueID_place_of_issue, "placeOfIssue")}
            {renderField(languageSDK.language.trueID_permanent_address, "permanentAddress")}
          </div>

          {/* Submit button */}
          <div
            style={{
              padding: 20,
              borderTop: '1px solid #eee',
              background: '#fff',
              position: 'sticky',
              bottom: 0
            }}
          >
            <button
              type="submit"
              style={{
                width: '100%',
                backgroundColor: configEkyc.buttonCaptureColor,
                color: configEkyc.titleButtonCaptureColor,
                padding: '12px 15px',
                border: 'none',
                borderRadius: 5,
                cursor: 'pointer'
              }}
            >
              {languageSDK.language.trueID_submit}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default EditOCRScreen;
